// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css/livewires.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCharts from 'vue-charts'
import Chart from 'chart.js'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import Tooltip from 'vue-directive-tooltip'
import VeeValidate from 'vee-validate'
import VueShortkey from 'vue-shortkey'
import en from './strings/validator/en'
import App from './App.vue'
import firebase from 'firebase'
import { sync } from 'vuex-router-sync'
import { routes } from './routes'
import store from './store/store'

const router = new VueRouter({
  routes,
  mode: 'history'
})
sync(store, router)

Vue.use(VueRouter)
Vue.use(VueCharts)
Vue.use(VueClipboard)
Vue.use(VueCookies)
Vue.use(VueShortkey)
Vue.use(Tooltip, {
  placement: 'left'
})

const validateConfig = {
  classes: true,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'valid',
    invalid: 'invalid',
    pristine: 'pristine',
    dirty: 'dirty'
  }
}
VeeValidate.Validator.localize(en)
Vue.use(VeeValidate, validateConfig)

Vue.directive('focus', {
  inserted: function (el, binding) {
    if (binding.value) {
      el.focus()
    }
  }
})

Vue.filter('currency', (value) => {
  let amount = value
  let extension = ''
  const currency = store.getters.organization.currency
  amount = Math.round(amount)
  if (amount < 100000) {
    amount = Math.round(amount)
  }
  if (amount > 99999 && amount < 1000000) {
    amount = Math.round(amount / 1000).toFixed(2)
    extension = 'k'
  }
  if (amount > 999999 && amount < 1000000000) {
    amount = (amount / 1000000).toFixed(2)
    // amount = Math.round(amount / 100) * 100
    extension = 'M'
  }
  if (amount > 999999999) {
    amount = (amount / 1000000000).toFixed(2)
    extension = 'B'
  }
  amount = new Intl.NumberFormat('en-US').format(amount)
  return currency + amount + extension
})

Vue.filter('lowercase', (value) => {
  return value.toLowerCase()
})

Vue.filter('percent', (value) => {
  return Math.round(value * 100) + '%'
})

Vue.filter('round', (value) => {
  return Math.round(value)
})

Vue.filter('round1', (value) => {
  return Math.round(value * 10) / 10
})

Vue.filter('round2', (value) => {
  return Math.round(value * 100) / 100
})

Vue.filter('pluralize', (value, word) => {
  const phrase = value + '\xa0' + word
  if (value === 1) {
    return phrase
  } else {
    return phrase + 's'
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!firebase.default.auth().currentUser) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
const unsubscribe = firebase.default.auth().onAuthStateChanged(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    created () {
      const vm = this
      firebase.default.auth().onAuthStateChanged((_user) => {
        console.log(_user)
        // vm.$store.dispatch('toggleLoading', true)
        if (_user) {
          const user = {
            user: _user.uid,
            redirect: vm.$cookies.get('redirect')
          }
          if (vm.$route.query.redirect) {
            vm.$cookies.set('redirect', vm.$route.query.redirect, '60s')
          }
          if (vm.$cookies.get('redirect')) {
            user.redirect = vm.$cookies.get('redirect')
          }
          vm.$store.dispatch('checkUser', user)
        }
      })
    },
    mounted () {
      Chart.defaults.global.defaultFontSize = 12
      Chart.defaults.global.defaultFontColor = '#9E9C9A'
      Chart.defaults.global.defaultFontFamily = '"Acumin Pro", system, -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", "Arial", sans-serif'
      Chart.scaleService.updateScaleDefaults('linear', {
        ticks: {
          showLabelBackdrop: false
        }
      })
    },
    template: '<App/>'
  })
  unsubscribe()
})
